module.exports = __webpack_public_path__ + "img/Besenmodel.f61e0897.svg";